const _ = require('underscore');
const Backbone = require('backbone');
const RecommendedOptionModel = require('app/models/store/client/product/recommendedoption');
module.exports = Backbone.Collection.extend({
	/**
	 * @return {string}
	 */
	url: function() {
		if (this.uniqueId) {
			return `/app/api/products/${this.uniqueId}/recommendedOptions`;
		}
		return '';
	},

	model: RecommendedOptionModel,

	/**
	 * getSelectedOptions - Find all selected recommended options
	 * @return {Array} Selected Priced Options
	 */
	getSelectedOptions: function() {
		var found = _.reduce(
			this.models,
			function(memo, value, key, list) {
				var selectedOption = list[key].getSelected();
				if (selectedOption.length && list[key].get('isNeeded')) {
					selectedOption[0].set('quantity', list[key].getQuantity());
					memo.push(selectedOption);
				}
				return memo;
			},
			[]
		);
		return _.flatten(found) || [];
	},

	/**
	 * getSelectedOptionsPrice - Sum together all of the active recommended options
	 * @return {Number} Sum of configuration options
	 */
	getSelectedOptionsPrice: function() {
		return _.reduce(
			this.getSelectedOptions(),
			function(memo, option) {
				return memo + option.get('price');
			},
			0
		);
	},

	/**
	 * getDecoratedSelectedOptions - Shortcut to get the json of the selected recommended options
	 * @return {Array} Actively selected ids
	 */
	getDecoratedSelectedOptions: function() {
		return _.map(this.getSelectedOptions(), function(i) {
			return {
				uniqueId: i.get('uniqueId'),
				quantity: i.get('quantity')
			};
		});
	}
});
